import { ReactElement, useCallback } from 'react';
import { createFetchContext } from '../../../../../components/contexts/FetchContextFactory';
import DisplayError from '../../../../../components/info/DisplayError';
import Loading from '../../../../../components/info/Loading';
import { StudentDocumentsResponse } from '../types';
import { getStudentDocuments } from '../../../api/studentDocumentsRequests';

export interface StudentDocumentsProps<T> {
  studentId: number;
  children: (props: { data: T; refresh: () => Promise<void> }) => ReactElement;
}

const { FetchProvider, FetchConsumer } = createFetchContext<
  undefined,
  StudentDocumentsResponse
>();

export const StudentDocumentsLoaderConsumer = FetchConsumer;

export function StudentDocumentsLoader({
  studentId,
  children,
}: StudentDocumentsProps<StudentDocumentsResponse>) {
  const request = useCallback(() => {
    return getStudentDocuments(studentId);
  }, [studentId]);
  return (
    <FetchProvider request={request} defaultQuery={undefined} fetchImmediately>
      <FetchConsumer>
        {({ data, loading, error, refresh }) => {
          if (error) {
            return (
              <DisplayError
                insideCard
                textBody={error.code}
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          if (loading) {
            return (
              <div className="mx-3">
                <Loading insideCard />
              </div>
            );
          }

          if (!data) {
            return (
              <DisplayError
                insideCard
                textBody="Data no cargada"
                retryAction={refresh}
                loadingAction={loading}
              />
            );
          }

          return children({ data, refresh });
        }}
      </FetchConsumer>
    </FetchProvider>
  );
}
